/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PRODUCTION_APP_ROOT_DOMAIN } from 'libs/utils/constants';

const __vue_script__ = {
    name: 'GettingStarted',

    data() {
        return {
            currentTab: 'javascript',
            apiRootDomain: `https://api${PRODUCTION_APP_ROOT_DOMAIN}`
        };
    },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"getting-started"},[_c('h2',[_vm._v("Introduction")]),_vm._m(0),_c('p',[_vm._v("The SpotMe API potentially differs for every workspace you own as it depends on the modules you have installed and the potential data model changes you have defined to best suit your needs. Log in to see docs customized for your workspaces.")]),_c('h2',[_vm._v("API developer access")]),_vm._m(1),_c('h2',[_vm._v("Authentication")]),_vm._m(2),_vm._m(3),_c('h2',[_vm._v("Getting a token")]),_c('ol',[_vm._m(4),_c('li',[_vm._v("Once you are logged into Backstage, click on your initials located at the bottom left corner of the screen, and then click on your name:"),_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.$utils.assets.imagePath('api-docs/user_menu.jpg'),"srcset":_vm.$utils.assets.imagePath('api-docs/user_menu.jpg', '3x'),"alt":"User menu"}})])]),_c('li',[_vm._v("Click on the API tokens tab, and then on Create a token:"),_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.$utils.assets.imagePath('api-docs/api_tokens.jpg'),"srcset":_vm.$utils.assets.imagePath('api-docs/api_tokens.jpg', '3x'),"alt":"API tokens"}})])]),_c('li',[_vm._v("A window will appear asking for an identifier for your new token. Enter the application name as the identifier, and then click on Create:"),_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.$utils.assets.imagePath('api-docs/create.jpg'),"srcset":_vm.$utils.assets.imagePath('api-docs/create.jpg', '3x'),"alt":"Create token"}})])]),_c('li',[_vm._v("A new popup with your new token (string of characters) will be displayed. Please note that this will be the only time you will ever see your token, so, please take note of it in a secure place:"),_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.$utils.assets.imagePath('api-docs/token.jpg'),"srcset":_vm.$utils.assets.imagePath('api-docs/token.jpg', '3x'),"alt":"Your token"}})])]),_vm._m(5)]),_c('h2',[_vm._v("Deleting a token")]),_c('p',[_vm._v("In order to delete a token, click on the delete button showing in red:")]),_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.$utils.assets.imagePath('api-docs/delete.png'),"srcset":_vm.$utils.assets.imagePath('api-docs/delete.png', '3x'),"alt":"Delete a token"}})]),_c('h2',[_vm._v("Using a token")]),_c('p',[_vm._v("Now that you have a valid token you can make authorized requests as follow:"),_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item",class:{active: (_vm.currentTab == "javascript")}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.currentTab = "javascript"}}},[_vm._v("Javascript")])]),_c('li',{staticClass:"nav-item",class:{active: (_vm.currentTab == "curl")}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.currentTab = "curl"}}},[_vm._v("Curl")])]),_c('li',{staticClass:"nav-item",class:{active: (_vm.currentTab == "ruby")}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.currentTab = "ruby"}}},[_vm._v("Ruby")])])]),_c('pre',{directives:[{name:"code-highlight",rawName:"v-code-highlight"},{name:"show",rawName:"v-show",value:(_vm.currentTab === 'javascript'),expression:"currentTab === 'javascript'"}],staticClass:"example javascript"},[_vm._v("const myToken = 'token';\nconst url = '"+_vm._s((_vm.apiRootDomain + "/api/v2/me"))+"';\n// Using `fetch`\nfetch(url, {\n   headers: {\n       'Authorization': `Bearer ${myToken}`\n   }\n});\n// Using Axios.js ( https://github.com/axios/axios )\n$axios.get(url, {\n   headers: {\n       'Authorization': `Bearer ${myToken}`\n   }\n});")]),_c('pre',{directives:[{name:"code-highlight",rawName:"v-code-highlight"},{name:"show",rawName:"v-show",value:(_vm.currentTab === 'curl'),expression:"currentTab === 'curl'"}],staticClass:"example bash"},[_vm._v("curl -H \"Accept: application/json\" -H \"Authorization: Bearer ${TOKEN}\" "+_vm._s((_vm.apiRootDomain + "/api/v2/me ")))]),_c('pre',{directives:[{name:"code-highlight",rawName:"v-code-highlight"},{name:"show",rawName:"v-show",value:(_vm.currentTab === 'ruby'),expression:"currentTab === 'ruby'"}],staticClass:"example ruby"},[_vm._v("require \"net/http\"\nrequire \"uri\"\ntoken = \"token\"\nuri = URI.parse(\""+_vm._s((_vm.apiRootDomain + "/api/v2/me "))+"\")\nhttp = Net::HTTP.new(uri.host, uri.port)\nrequest = Net::HTTP::Get.new(uri.request_uri)\nrequest[\"Authorization\"] = \"Bearer #{token}\"\nresponse = http.request(request)")])]),_c('h2',[_vm._v("Technical notes")]),_vm._m(6)])}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The SpotMe API is organized around"),_c('a',{attrs:{"href":"http://en.wikipedia.org/wiki/Representational_State_Transfer","target":"_blank"}},[_vm._v(" REST")]),_vm._v(". Our API has predictable resource-oriented URLs, accepts"),_c('a',{attrs:{"href":"http://www.json.org/","target":"_blank"}},[_vm._v(" JSON-encoded")]),_vm._v(" request bodies, returns JSON-encoded responses, and uses standard HTTP response codes, authentication, and verbs.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("In order to start using the SpotMe API, you will need to ask your SpotMe Organization Admin for an"),_c('strong',[_vm._v(" API Developer")]),_vm._v(" access.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("SpotMe uses "),_c('strong',[_vm._v("Bearer authentication")]),_vm._v(" for protected API calls.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Bearer authentication")]),_vm._v(" (also called"),_c('strong',[_vm._v(" token authentication")]),_vm._v(") is an HTTP authentication scheme that involves security tokens called bearer tokens and was originally created as part of "),_c('a',{attrs:{"href":"https://oauth.net/2/","target":"_blank"}},[_vm._v("OAuth 2.0.")]),_vm._v(" The name \"Bearer authentication\" can be understood as \"give access to the bearer of this token.\"\n The bearer token is a cryptic string, generated from the backstage user as described below.\n The API client must send this token in the Authorization header when making requests to protected resources:"),_c('pre',[_vm._v("Authorization: Bearer <token>")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._v("Once you are granted an API Developer access, log in to Backstage at"),_c('a',{attrs:{"href":"https://backstage.spotme.com/"}},[_vm._v(" https://backstage.spotme.com/.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._v("Click"),_c('strong',[_vm._v(" Dismiss")]),_vm._v(" to close the token window.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("The token is valid for 5 years.")]),_c('li',[_vm._v("The token is valid for all the workspaces that its creator has access to.")]),_c('li',[_vm._v("The token is personal, do not share it with other people.")])])}]

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "GettingStarted.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__